<template>
  <div>
    <ts-loading-banner :loading="waiting">
      <form @submit.prevent="bill">
        <!-- begin invoice -->
        <div class="invoice">
          <!-- begin invoice-header -->
          <div class="invoice-header">
            <div class="invoice-from">
              <small>{{ $t('restaurantSale.orderInfo') }}</small>
              <address class="m-t-5 m-b-5">
                <strong class="text-inverse">{{ $t('restaurantSale.order') }}: #{{
                  tableSelected.order_no
                }}</strong><br />
                {{ $t('restaurantSale.status') }}:
                {{ tableSelected.invoice_status }}<br />
                Fx: {{ defaultCrrency }} 1 = {{ toCurrency }} {{ exchangeRate }}
              </address>
            </div>
            <div class="invoice-to">
              <small>{{ $t('restaurantSale.tableInfo') }}</small>
              <address class="m-t-5 m-b-5">
                <strong class="text-inverse">{{ $t('restaurantSale.table') }}:
                  {{ tableSelected.table_no }}</strong><br />
                {{ $t('restaurantSale.status') }}: {{ tableSelected.status_name
                }}<br />
                {{ $t('restaurantSale.numberOfCustomer') }}:
                {{ tableSelected.num_customer_status }}<br />
              </address>
            </div>
            <div class="invoice-date">
              <small>{{ $t('restaurantSale.dateAndTime') }}</small>
              <div class="date text-inverse m-t-5">
                {{ currentDate }}
              </div>
              <div class="invoice-detail">
                {{ $t('restaurantSale.startTime') }}:
                {{ tableSelected.start_time }} <br />
                {{ $t('restaurantSale.now') }}: {{ time }}
              </div>
            </div>
          </div>
          <!-- end invoice-header -->
          <!-- begin invoice-content -->
          <div class="invoice-content">
            <!-- begin invoice-price -->
            <div class="invoice-price">
              <div class="invoice-price-left">
                <div class="invoice-price-row" style="width: 100%">
                  <div class="sub-price" style="width: 25%;margin-top: -8px;">
                    <small>{{ $t('restaurantSale.subtotal') }}</small>
                    <span class="text-inverse">{{ defaultCrrency }}
                      {{ model.sub_total | format_number }}</span>
                  </div>
                  <div class="sub-price" style="width: 25%;margin-top: -8px;">
                    <small>{{ $t('restaurantSale.preChargeAmount') }}</small>
                    <span class="text-inverse">{{ defaultCrrency }}
                      {{
                        tableSelected.total_pre_charge_amount | format_number
                      }}</span>
                  </div>
                  <div class="sub-price text-center" style="width: 170px">
                    <small>{{ $t('restaurantSale.discount') }}</small>
                    <b-input-group size="sm">
                      <b-input-group-prepend is-text>
                        <input type="radio" v-model="model.discount_type" id="dolar" :value="'$'" />
                        &nbsp;$
                      </b-input-group-prepend>
                      <b-form-input v-model.number="model.discount_rate" class="text-center form-control"
                        @input="calculate" ref="discount_rate" @focus="
                          () => [
                            (ref_input_last_focus = 'discount_rate'),
                            (value_keyboard_input = model.discount_rate)
                          ]
                        "></b-form-input>
                      <b-input-group-prepend is-text for="percentage">
                        <input type="radio" v-model="model.discount_type" id="percentage" :value="'%'" />
                        &nbsp;%
                      </b-input-group-prepend>
                    </b-input-group>
                  </div>
                  <div class="sub-price text-right" style="width: 25%; margin-top: -8px;">
                    <small>{{ $t('restaurantSale.vat') }}
                      {{ vatRate ? '(' + vatRate + '%)' : '' }}</small>
                    <span class="text-inverse">
                      {{ defaultCrrency }}
                      {{ model.vat_amount | format_number }}</span>
                  </div>
                </div>
              </div>
              <div class="invoice-price-right" style="background: #808B96;">
                <small>{{ $t('restaurantSale.total') }}</small>
                <span class="f-w-600">{{ defaultCrrency }}
                  {{ model.grand_total | format_number }}</span>
              </div>
            </div>
            <br />
            <div class="payment">
              <div class="row">
                <div class="col-md-3">
                  <div id="keyboard">
                    <!-- @onKeyPress="onKeyPress" -->
                    <ts-simple-keyboard @onChange="onChangeKeyBoard" :input="value_keyboard_input" :theme="theme" />
                  </div>
                  <!-- Bank info -->
                  <div v-if="tableSelected.member_card" class="mt-2 d-flex flex-column align-items-center">
                    <MemberCard :table="tableSelected.member_card" />
                  </div>
                  <!-- Bank info -->
                  <!-- <div class="mt-2 d-flex flex-column align-items-center">
                    <img v-show="selectedBankLogo" class="ts-rounded ts-h-20 ts-w-20" v-lazy="{
                      src: selectedBankLogo,
                      error: require('@/assets/logo.png'),
                      loading: require('@/assets/Rolling-1s-200px.svg'),
                      preLoad: 1.3,
                      attempt: 1
                    }" />
                    <div class="text-center">
                      <span>{{ model.bank_name }}</span>
                      <h6 v-if="model.account_name" class="text-center ts-font-bold mt-2 mb-0 text-uppercase text-info">
                        Name: {{ model.account_name }}
                      </h6>
                      <h6 v-if="model.account_number"
                        class="text-center ts-font-bold mt-2 mb-0 text-uppercase text-info">
                        Account #: {{ model.account_number }}
                      </h6>
                    </div>
                  </div> -->
                </div>
                <div class="col-md-9">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="col-form-label">
                        &diams; {{ $t('restaurantSale.cashPayment') }}</label>
                    </div>
                    <div class="col-md-6">
                      <label class="col-form-label">
                        &diams; {{ $t('restaurantSale.cashBack') }}</label>
                    </div>
                  </div>
                  <div class="invoice-price">
                    <div class="invoice-price-left">
                      <div class="form__group field">
                        <input ref="paid_in_default_currency" type="number" class="form__field" :placeholder="$t('restaurantSale.cashPayment') + defaultCrrency
                          " v-model="paid_in_default_currency" min="0" @input="calculate" @focus="
                            () => [
                              (ref_input_last_focus =
                                'paid_in_default_currency'),
                              (value_keyboard_input = paid_in_default_currency)
                            ]
                          " />
                        <label for="name" class="form__label">
                          {{ $t('restaurantSale.cashIn') }}
                          {{ defaultCrrency }}</label>
                      </div>
                    </div>
                    <div class="invoice-button">
                      <a @click.prevent="pickupAmountDefulatCurrency" class="btn btn-default">
                        <i class="fas fa-arrow-left fa-3x ts-pt-8"></i>
                      </a>
                    </div>
                    <div class="invoice-price-right">
                      <span class="f-w-600 text-success" :class="{
                        'text-danger': change_in_default_currency < 0
                      }">{{ defaultCrrency }}
                        {{ change_in_default_currency | format_number }}</span>
                    </div>
                  </div>
                  <div class="invoice-price">
                    <div class="invoice-price-left">
                      <div class="form__group field">
                        <input ref="paid_in_to_currency" type="number" class="form__field" :placeholder="$t('restaurantSale.cashPayment') + toCurrency
                          " v-model="paid_in_to_currency" min="0" @input="calculate" @focus="
                            () => [
                              (ref_input_last_focus = 'paid_in_to_currency'),
                              (value_keyboard_input = paid_in_to_currency)
                            ]
                          " />
                        <label for="name" class="form__label">
                          {{ $t('restaurantSale.cashIn') }}
                          {{ toCurrency }}</label>
                      </div>
                    </div>
                    <div class="invoice-button">
                      <a @click.prevent="pickupAmountToCurrency" class="btn btn-default">
                        <i class="fas fa-arrow-left fa-3x ts-pt-8"></i>
                      </a>
                    </div>
                    <div class="invoice-price-right">
                      <span class="f-w-600 text-success" :class="{ 'text-danger': change_in_to_currency < 0 }">{{
                        toCurrency }}
                        {{ change_in_to_currency | format_number }}</span>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">&diams; {{ $t('restaurantSale.otherPayment') }}</label>
                    <div class="col-md-5">
                      <ul class="list-inline payment-type">
                        <li :class="{ active: isActive == 'bank_transfer' }">
                          <a v-tooltip="$t('martSale.bankTransfer')" @click="
                              ;[
                            (isActive = 'bank_transfer'),
                            (model.bank_transfer = null),
                            (model.payment_method_id = 3)
                          ]
                          onPaymentMethodChange()
                            ">
                            <i class="fa fa-university"></i>
                          </a>
                        </li>
                        <li :class="{ active: isActive == 'paid_by_cheque' }" v-if="false">
                          <a v-tooltip="$t('martSale.paidByCheque')" @click="
                              ;[
                            (isActive = 'paid_by_cheque'),
                            (model.paid_by_cheque = null),
                            (model.payment_method_id = 2)
                          ]
                          onPaymentMethodChange()
                            ">
                            <i class="fas fa-money-check-alt"></i>
                          </a>
                        </li>
                        <li :class="{ active: isActive == 'credit_card' }" v-if="false">
                          <a v-tooltip="$t('restaurantSale.creditCard')" @click="
                              ;[
                            (isActive = 'credit_card'),
                            (model.paid_in_coupon = null),
                            (model.payment_method_id = 4)
                          ]
                          onPaymentMethodChange()
                            "><i class="far fa-credit-card"></i></a>
                        </li>
                        <li :class="{ active: isActive == 'coupon' }">
                          <a v-tooltip="$t('restaurantSale.coupon')" @click="
                              ;[
                            (isActive = 'coupon'),
                            (model.paid_in_credit_card = null),
                            (model.payment_method_id = 1)
                          ]
                          onPaymentMethodChange()
                            "><i class="fab fa-contao"></i></a>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-5 mt-1" style="margin-left: -4px;">
                      <!-- <div class="option-row">
                        <textarea rows="2" class="form-control" :value="remarks"
                          @input="$emit('update-remarks', $event.target.value)"
                          :placeholder="$t('restaurantSale.remarks')"></textarea>
                      </div> -->
                      <div class="option-row">
                        <label class="col-form-label" style="padding-bottom: 0px;">
                          {{ $t('restaurantSale.remarks') }}
                        </label>
                        <a-select v-model="model.remarks" :options="remarksOptions" allowClear show-search
                          :show-arrow="false" option-filter-prop="children" class="ts-w-full"
                          :class="{ 'is-invalid': errors.has('serial_no') }" placeholder="Remarks"
                          @search="handleSearchRemarks"></a-select>
                      </div>
                      <a-alert class="ts-mt-1" v-if="
                        errors.has('change_in_usd') ||
                        errors.has('change_in_riel')
                      " message="Payment" :description="errors.first('change_in_usd')
                        ? errors.first('change_in_usd')
                        : errors.first('change_in_riel')
                        " type="error" show-icon closable />
                    </div>
                  </div>
                  <div class="form-group row" v-if="
                    isActive == 'bank_transfer' ||
                    isActive == 'paid_by_cheque' ||
                    isActive == 'credit_card'
                  ">
                    <label class="col-md-2 col-form-label">&diams; {{ titleName }}</label>
                    <div class="col-md-10">
                      <ul class="ts-grid ts-grid-cols-11 ts-gap-11">
                        <li v-if="!model.bank_name" v-for="(record, index) in bankNameOptions" :key="index">
                          <a v-tooltip="record.label" @click="
                              ;[(model.bank_name = record.label)]
                          bankNameChange()
                            ">
                            <img class="ts-rounded ts-h-12 ts-w-12" v-lazy="{
                              src: record.bank_logo,
                              error: require('@/assets/logo.png'),
                              loading: require('@/assets/Rolling-1s-200px.svg'),
                              preLoad: 1.3,
                              attempt: 1
                            }" />
                          </a>
                        </li>
                      </ul>
                      <ul class="list-inline">
                        <li v-if="model.bank_name" v-for="(record, index) in accountOptions" :key="index">
                          <a :title="$t('martSale.bankTransfer')" @click="
                              ;[(model.account_number = record.value)]
                          accountChange()
                            " :class="{
                              active: model.account_number == record.value
                            }" class="btn btn-outline-info btn-sm">
                            <span>
                              {{ model.bank_name }}<br />
                              {{ record.name }}<br />
                              {{ record.label }}
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="form-group row">
                    <a-alert v-if="errors.has('account_number')" message="Payment"
                      :description="errors.first('account_number')" type="error" show-icon closable />
                    <div class="col-md-12">
                      <!-- bank_transfer -->
                      <div class="invoice-price" v-if="isActive == 'bank_transfer'">
                        <div class="invoice-price-left">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form__group field">
                                <input type="number" class="form__field" :placeholder="$t('martSale.bankTransferInUsd')
                                  " min="0" v-model.number="model.bank_transfer" @input="calculate" required
                                  ref="bank_transfer_usd" />
                                <label for="name" class="form__label">
                                  {{ $t('martSale.bankTransferInUsd') }}
                                </label>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form__group field">
                                <input type="number" class="form__field" :placeholder="$t('martSale.bankTransferInRiel')
                                  " min="0" v-model.number="model.bank_transfer_riel" @input="calculate" required
                                  ref="bank_transfer_riel" />
                                <label for="name" class="form__label">
                                  {{ $t('martSale.bankTransferInRiel') }}
                                </label>
                              </div>
                            </div>
                          </div>
                          <a-alert v-if="
                            errors.has('bank_transfer') ||
                            errors.has('bank_transfer_riel')
                          " message="Payment" :description="errors.first('bank_transfer')
                            ? errors.first('bank_transfer')
                            : errors.first('bank_transfer_riel')
                            " type="error" show-icon closable />
                        </div>
                      </div>

                      <!-- paid_by_cheque -->
                      <div class="invoice-price" v-if="isActive == 'paid_by_cheque'">
                        <div class="invoice-price-left">
                          <div class="form__group field">
                            <input type="number" class="form__field" :placeholder="$t('martSale.paidByChequeInUsd')"
                              min="0" v-model.number="model.paid_by_cheque" @input="calculate" required
                              ref="paid_by_cheque" />
                            <label for="name" class="form__label">
                              {{ $t('martSale.paidByChequeInUsd') }}
                            </label>
                          </div>
                        </div>

                        <div class="invoice-price-right-gray">
                          <div class="ts-w-full mt-1">
                            <a-alert v-if="errors.has('paid_by_cheque')" message="Payment"
                              :description="errors.first('paid_by_cheque')" type="error" show-icon closable />
                          </div>
                        </div>
                      </div>

                      <!-- credit_card -->
                      <div class="invoice-price" v-if="isActive == 'credit_card'">
                        <div class="invoice-price-left">
                          <div class="form__group field">
                            <input type="number" class="form__field" :placeholder="$t('martSale.creditCardInUsd')"
                              min="0" v-model.number="model.paid_in_credit_card" @input="calculate" required
                              ref="paid_in_credit_card" />
                            <label for="name" class="form__label">
                              {{ $t('martSale.creditCardInUsd') }}
                            </label>
                          </div>
                        </div>
                        <div class="invoice-price-right-gray">
                          <div class="ts-w-full mt-1">
                            <a-alert v-if="errors.has('paid_in_credit_card')" message="Payment"
                              :description="errors.first('paid_in_credit_card')" type="error" show-icon closable />
                          </div>
                        </div>
                      </div>

                      <!-- coupon -->
                      <div class="invoice-price" v-if="isActive == 'coupon'">
                        <div class="invoice-price-left">
                          <div class="form__group field">
                            <input type="number" class="form__field" :placeholder="$t('martSale.couponInUsd')" min="0"
                              v-model.number="model.paid_in_coupon" @input="calculate" required
                              v-if="isActive == 'coupon'" ref="paid_in_coupon" @focus="
                                () => [
                                  (ref_input_last_focus = 'paid_in_coupon'),
                                  (value_keyboard_input = model.paid_in_coupon)
                                ]
                              " />
                            <label for="name" class="form__label">
                              {{ $t('martSale.couponInUsd') }}
                            </label>
                          </div>
                        </div>
                        <div class="invoice-price-right-gray">
                          <div class="ts-w-full mt-1">
                            <a-alert v-if="errors.has('paid_in_coupon')" message="Payment"
                              :description="errors.first('paid_in_coupon')" type="error" show-icon closable />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end invoice-content -->
        </div>
        <!-- end invoice -->
        <!-- begin invoice-footer -->
        <div class="invoice-footer">
          <div class="row">
            <div class="col-lg-3">
              <div style="padding-left:20px">
                <ts-checkbox v-model="model.is_city_ledger">{{
                  $t('restaurantSale.cityLedger')
                }}</ts-checkbox>
                <ts-checkbox v-model="model.is_customer_ledger">{{
                  $t('restaurantSale.customerLedger')
                }}</ts-checkbox>
                <ts-checkbox v-model="model.is_clear_table">{{
                  $t('restaurantSale.isCleanFromTable')
                }}</ts-checkbox>
              </div>
            </div>
            <div class="col-lg-9">
              <div class="btn-row pull-right">
                <ts-button class="btn btn-default" :disabled="waiting" @click.prevent="$emit('close')">
                  {{ $t('cancel') }}</ts-button>
                <ts-button type="submit" @click.prevent="bill" :waiting="waiting" class="btn btn-success btn-lg"><i
                    v-if="!waiting" class="fas fa-check fa-fw fa-lg"></i>
                  {{ $t('restaurantSale.bill') }}</ts-button>
              </div>
            </div>
          </div>
        </div>
        <!-- end invoice-footer -->
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Swal from 'sweetalert2'
import { mapActions } from 'vuex'
import { debounce } from 'lodash'
import MemberCard from './MemberCheckOutTableCard.vue'

export default {
  name: 'checkBill',
  components: {
    MemberCard
  },
  data() {
    return {
      ref_input_last_focus: 'paid_in_default_currency',
      value_keyboard_input: null,
      theme: 'hg-theme-default hg-layout-numeric numeric-theme',
      show_bank: false,
      model: {
        stock_out_id: null,
        table_id: null,
        counter_id: null,
        paid_in_riel: null,
        paid_in_usd: null,
        paid_in_coupon: null,
        paid_in_credit_card: null,
        change_in_riel: null,
        change_in_usd: null,
        sub_total: null,
        discount_type: '%',
        discount_rate: null,
        discount_amount: null,
        total_after_discount: null,
        vat_amount: null,
        grand_total: null,
        is_clear_table: true,
        is_city_ledger: false,
        is_customer_ledger: false,
        products: [],
        payment_method_id: 1,
        bank_name: null,
        account_number: null,
        account_name: null,
        bank_transfer: null,
        paid_by_cheque: null,
        bank_transfer_riel: null,
        total_pre_charge_amount: null,
        remarks: null,
      },
      paid_in_default_currency: null,
      paid_in_to_currency: null,
      change_in_default_currency: 0,
      change_in_to_currency: 0,
      time: '00:00',
      waiting: false,
      isActive: '',
      paymentMethods: [],
      errors: new Errors(),
      bankProfiles: [],
      remarksOptions: []
    }
  },
  created() {
    this.handleStartTime()
    this.setDataOnSelectedTable()
    this.model.counter_id = parseInt(localStorage.getItem('counterId'))
    this.fetchResource()
  },
  mounted() {
    this.$refs.paid_in_default_currency.focus()
    this.$refs.paid_in_default_currency.select()
  },
  filters: {
    format_number(value) {
      return `${parseFloat(value).toLocaleString()}`
    }
  },
  computed: {
    isShow: vm => arrayValue => {
      return _.includes(arrayValue, vm.model.payment_method_id)
    },
    notDisableFor: vm => arrayValue => {
      return !_.includes(arrayValue, vm.model.payment_method_id)
    },
    tableSelected() {
      return this.$store.state.restaurantSale.counterCheckout.tableSelected
    },
    currentDate() {
      return moment().format('dddd, MMMM Do')
    },
    vatRate() {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.vat_rate
      )
    },
    exchangeRate() {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.fx_rate
      )
    },
    defaultCrrency() {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .default_currency
    },
    toCurrency() {
      if (this.defaultCrrency == 'KHR') {
        return 'USD'
      }

      return 'KHR'
    },
    paymentMethodOptions() {
      if (this.paymentMethods) {
        return this.paymentMethods.map(pm => ({
          value: pm.payment_method_id,
          label: pm.payment_method
        }))
      }
      return []
    },
    bankNameOptions() {
      return this.bankProfiles.map(el => ({
        value: el.bank_name,
        label: el.bank_name,
        bank_logo: el.bank_logo
      }))
    },
    accountOptions() {
      let acc = this.bankProfiles.filter(
        b => b.bank_name == this.model.bank_name
      )[0]
      if (acc) {
        return acc.accounts.map(el => ({
          value: el.account_number,
          label: el.account_number,
          name: el.account_name
        }))
      }
      return []
    },
    titleName() {
      switch (this.isActive) {
        case 'coupon':
          return 'Coupon'
        case 'credit_card':
          return 'Credit Card'
        case 'bank_transfer':
          return 'Bank Transfer'
        case 'paid_by_cheque':
          return 'Cheque'
      }
    },
    selectedBankLogo() {
      return this.bankProfiles
        .filter(b => b.bank_name == this.model.bank_name)
        .reduce((init, value) => (init = value.bank_logo), null)
    }
  },
  methods: {
    ...mapActions('restaurantSale/counterCheckout', [
      'bankProfile',
      'remarks',
      'paymentMethod'
    ]),
    handleSearchRemarks: debounce(async function (value) {
      if (!this.remarksOptions.find(el => el.value == value || el.label == value) && value) {
        this.remarksOptions.push({
          value: value,
          label: value,
        })
      }
    }, 500),
    setDataOnSelectedTable() {
      if (!_.isEmpty(this.tableSelected)) {
        this.model.stock_out_id = this.tableSelected.stock_out_id
        this.model.table_id = this.tableSelected.table_id
        this.paid_in_default_currency = parseFloat(
          this.tableSelected.invoice_amount -
          this.tableSelected.total_pre_charge_amount
        )
      }
      this.calculate()
    },
    cookingStatus(cooking_status_id) {
      if (cooking_status_id == 1) {
        return 'text-info'
      }
      if (cooking_status_id == 2) {
        return 'text-primary'
      }
      if (cooking_status_id == 3) {
        return 'text-success'
      }
      return 'text-danger'
    },
    bill() {
      if (this.waiting) return
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'restaurantSale/counterCheckout/store',
          Object.assign({}, this.model, {
            counter_id: parseInt(localStorage.getItem('counterId')),
            action_type: 'check-bill'
          })
        )
        .then(response => {
          if (response.message_id == 1) {
            this.$emit('close')
            Swal.fire({
              title: 'CHECK BILL',
              icon: 'success',
              html:
                response.message +
                '<br /><b>' +
                (response.next_locker_message ? (response.next_locker_message + '<br />') : '') +
                this.$t('restaurantSale.cashBack') +
                ': <span class="text-success">' +
                this.defaultCrrency +
                ' ' +
                parseFloat(this.change_in_default_currency).toLocaleString() +
                '</span> => <span class="text-success">' +
                this.toCurrency +
                ' ' +
                parseFloat(this.change_in_to_currency).toLocaleString() +
                '</span></b>',
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false
            })
          }
          if (response.message_id == 50021 || response.message_id == 50022) {
            this.fetchTableByInterval()
            this.$notification['error']({
              message: 'Submit Bill',
              description: response.message,
              placement: 'bottomRight'
            })
          }
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$notification['error']({
            message: 'Submit Bill',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.waiting = false
        })
    },
    productPhoto(item) {
      if (item.photo === null) return ''

      return `/api/files?filePath=${item.photo}`
    },
    handleCheckTime: function (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    handleStartTime: function () {
      var today = new Date()
      var h = today.getHours()
      var m = today.getMinutes()
      var a
      m = this.handleCheckTime(m)
      a = h > 11 ? ' PM' : ' AM'
      h = h > 12 ? h - 12 : h

      this.time = h + ':' + m + a
      setTimeout(() => {
        this.handleStartTime()
      }, 500)
    },
    calculate() {
      const isUSD = this.defaultCrrency === 'USD'
      const ex = this.exchangeRate

      // Safe rounding helper
      const round2 = val => Number(Number(val || 0).toFixed(2))

      // Always round raw inputs before using
      this.paid_in_default_currency = round2(this.paid_in_default_currency)
      this.paid_in_to_currency = round2(this.paid_in_to_currency)
      this.model.paid_in_coupon = round2(this.model.paid_in_coupon)
      this.model.paid_in_credit_card = round2(this.model.paid_in_credit_card)
      this.model.paid_by_cheque = round2(this.model.paid_by_cheque)
      this.model.bank_transfer = round2(this.model.bank_transfer)
      this.model.bank_transfer_riel = round2(this.model.bank_transfer_riel)
      this.model.discount_rate = round2(this.model.discount_rate)

      // Normalize helper
      const normalize = (val, multiply = true) =>
        isUSD ? round2(val / ex) : round2(val * (multiply ? ex : 1))

      // Cross-currency inputs
      let paid_in_to_currency = normalize(
        this.paid_in_to_currency,
        isUSD ? false : true
      )

      // ✅ FIX: These are already in default currency
      let paid_in_coupon = round2(this.model.paid_in_coupon)
      let paid_in_credit_card = round2(this.model.paid_in_credit_card)
      let paid_by_cheque = round2(this.model.paid_by_cheque)

      // ✅ FIX: bank_transfer is always in default currency
      let bank_transfer = round2(this.model.bank_transfer)

      // ✅ FIX: bank_transfer_riel convert only if default = USD
      let bank_transfer_riel = isUSD
        ? normalize(this.model.bank_transfer_riel, false)
        : round2(this.model.bank_transfer_riel)

      let paid_in_default_currency = round2(this.paid_in_default_currency)
      let discount_rate = round2(this.model.discount_rate)

      // Subtotal
      this.model.sub_total = round2(
        parseFloat(this.tableSelected.sub_total) -
        parseFloat(this.tableSelected.total_pre_charge_amount)
      )

      // Discount
      this.model.discount_amount =
        this.model.discount_type === '$'
          ? isUSD
            ? discount_rate
            : round2(discount_rate * ex)
          : round2((this.model.sub_total * discount_rate) / 100)

      // Totals
      this.model.total_after_discount = round2(
        this.model.sub_total - this.model.discount_amount
      )
      this.model.vat_amount = round2(
        (this.model.total_after_discount * this.vatRate) / 100
      )
      this.model.grand_total = round2(
        this.model.total_after_discount + this.model.vat_amount
      )

      // Change
      this.change_in_default_currency = round2(
        paid_in_default_currency +
        paid_in_to_currency +
        paid_in_coupon +
        paid_in_credit_card +
        paid_by_cheque +
        bank_transfer +
        bank_transfer_riel -
        this.model.grand_total
      )

      this.change_in_to_currency = round2(
        isUSD
          ? this.change_in_default_currency * ex
          : this.change_in_default_currency / ex
      )

      // Paid values
      if (isUSD) {
        this.model.paid_in_usd = round2(
          paid_in_default_currency +
          parseFloat(this.tableSelected.total_pre_charge_amount)
        )
        this.model.paid_in_riel = round2(this.paid_in_to_currency)
        this.model.change_in_usd = round2(this.change_in_default_currency)
        this.model.change_in_riel = round2(this.change_in_to_currency)
      } else {
        this.model.paid_in_riel = round2(
          paid_in_default_currency +
          parseFloat(this.tableSelected.total_pre_charge_amount)
        )
        this.model.paid_in_usd = round2(this.paid_in_to_currency)
        this.model.change_in_riel = round2(this.change_in_default_currency)
        this.model.change_in_usd = round2(this.change_in_to_currency)
      }

      // Pre-charge amount
      this.model.total_pre_charge_amount = parseFloat(
        this.tableSelected.total_pre_charge_amount
      )

      // Keep last input focus value (rounded!)
      this.value_keyboard_input = round2(
        ['paid_in_default_currency', 'paid_in_to_currency'].includes(
          this.ref_input_last_focus
        )
          ? this[this.ref_input_last_focus]
          : this.model[this.ref_input_last_focus]
      )
    },
    setValueCash(val) {
      if (val) {
        this.paid_in_default_currency = 0
        this.paid_in_to_currency = null
        this.clear()
      } else {
        this.paid_in_default_currency = null
        this.paid_in_to_currency = null
        this.clear()
      }
    },
    clear() {
      this.model.paid_in_coupon = null
      this.model.discount_amount = null
      this.model.discount_rate = null
      this.model.paid_in_credit_card = null
      this.model.bank_transfer = null
      this.model.bank_transfer_riel = null
      this.model.paid_by_cheque = null
      this.calculate()
    },
    onChangeKeyBoard(input) {
      this.value_keyboard_input = input ? input : null
      if (
        this.ref_input_last_focus == 'paid_in_default_currency' ||
        this.ref_input_last_focus == 'paid_in_to_currency'
      ) {
        this[this.ref_input_last_focus] = this.value_keyboard_input
      } else {
        this.model[this.ref_input_last_focus] = this.value_keyboard_input
      }
      this.calculate()
      setTimeout(() => {
        this.$refs[this.ref_input_last_focus].focus()
      }, 300)
    },
    pickupAmountDefulatCurrency() {
      this.paid_in_default_currency = -this.change_in_default_currency
      this.paid_in_to_currency = null
      this.calculate()
      this.$refs.paid_in_default_currency.focus()
    },
    pickupAmountToCurrency() {
      this.paid_in_to_currency = -this.change_in_to_currency
      this.paid_in_default_currency = null
      this.calculate()
      this.$refs.paid_in_to_currency.focus()
    },
    fetchTableByInterval(attributes) {
      this.$store
        .dispatch('restaurantSale/counterCheckout/fetchTables', attributes)
        .catch(error => {
          this.$notification['error']({
            message: 'FETCH TABLE',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => this.defaultCheckTable(this.model.table_id))
    },
    defaultCheckTable(table_id) {
      if (table_id) {
        this.autoSelectedTable(
          this.$store.state.restaurantSale.counterCheckout.tables
            .filter(t => t.table_id == table_id)
            .reduce((init, value) => (init = value), {})
        )
      }
    },
    autoSelectedTable(table) {
      this.$store.commit(
        'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
        table
      )
      if (!_.isEmpty(this.tableSelected)) {
        this.model.stock_out_id = this.tableSelected.stock_out_id
        this.model.table_id = this.tableSelected.table_id
      }
      this.calculate()
    },
    fetchResource() {
      this.loading = true
      this.paymentMethod()
        .then(response => {
          this.paymentMethods = response.data
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.loading = false
        })
      this.fetchBank()
      this.fetchRemarks()
    },
    fetchBank() {
      this.$emit('loading', true)
      this.bankProfile()
        .then(response => {
          this.bankProfiles = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    fetchRemarks() {
      this.$emit('loading', true)
      this.remarks()
        .then(response => {
          this.remarksOptions = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    bankNameChange() {
      this.model.account_number = null
      this.model.account_name = null
      this.model.paid_in_coupon = null
      this.model.paid_in_credit_card = null
      this.model.bank_transfer = null
      this.model.bank_transfer_riel = null
      this.model.paid_by_cheque = null
      if (this.accountOptions.length == 1) {
        this.model.account_name = this.accountOptions[0].name
        this.model.account_number = this.accountOptions[0].value
        this.focusInput()
        this.model.paid_in_usd = null
        this.model.paid_in_riel = null
      }
      this.calculate()
    },
    accountChange() {
      let account_name = this.accountOptions.find(
        el => el.value == this.model.account_number
      ).name
      this.model.account_name = account_name
      this.model.paid_in_coupon = null
      this.model.paid_in_usd = null
      this.model.paid_in_riel = null
      this.model.paid_in_credit_card = null
      this.model.bank_transfer = null
      this.model.bank_transfer_riel = null
      this.model.paid_by_cheque = null
      this.focusInput()
      this.calculate()
    },
    focusInput() {
      if (this.isActive == 'bank_transfer') {
        if (this.defaultCrrency == 'USD') {
          this.model.bank_transfer = this.paid_in_default_currency
          this.$nextTick(() => {
            this.$refs.bank_transfer_usd.focus()
            this.$refs.bank_transfer_usd.select()
          })
        }
        if (this.defaultCrrency == 'KHR') {
          this.model.bank_transfer_riel = this.paid_in_default_currency
          this.$nextTick(() => {
            this.$refs.bank_transfer_riel.focus()
            this.$refs.bank_transfer_riel.select()
          })
        }
        this.paid_in_default_currency = null
        this.paid_in_to_currency = null
      }
      if (this.isActive == 'paid_by_cheque') {
        if (this.defaultCrrency == 'USD') {
          this.model.paid_by_cheque = this.paid_in_default_currency
        }
        if (this.defaultCrrency == 'KHR') {
          this.model.paid_by_cheque = _.round(
            this.paid_in_default_currency / this.exchangeRate,
            2
          )
        }
        this.paid_in_default_currency = null
        this.paid_in_to_currency = null
        this.$nextTick(() => {
          this.$refs.paid_by_cheque.focus()
          this.$refs.paid_by_cheque.select()
        })
      }
      if (this.isActive == 'credit_card') {
        if (this.defaultCrrency == 'USD') {
          this.model.paid_in_credit_card = this.paid_in_default_currency
        }
        if (this.defaultCrrency == 'KHR') {
          this.model.paid_in_credit_card = _.round(
            this.paid_in_default_currency / this.exchangeRate,
            2
          )
        }
        this.paid_in_default_currency = null
        this.paid_in_to_currency = null
        this.$nextTick(() => {
          this.$refs.paid_in_credit_card.focus()
          this.$refs.paid_in_credit_card.select()
        })
      }
    },
    async onPaymentMethodChange() {
      this.model.paid_in_coupon = null
      this.model.paid_in_credit_card = null
      this.model.bank_transfer = null
      this.model.bank_transfer_riel = null
      this.model.paid_by_cheque = null
      if (this.model.payment_method_id == 1) {
        this.model.bank_name = null
        this.model.account_number = null
        this.model.account_name = ''
      } else {
        this.model.bank_name = null
        this.model.account_number = null
        this.model.account_name = null
      }
      if (this.isActive == 'coupon') {
        if (this.defaultCrrency == 'USD') {
          this.model.paid_in_coupon = this.paid_in_default_currency
        }
        if (this.defaultCrrency == 'KHR') {
          this.model.paid_in_coupon = _.round(
            this.paid_in_default_currency / this.exchangeRate,
            2
          )
        }
        this.paid_in_default_currency = null
        this.paid_in_to_currency = null
        this.$nextTick(() => {
          this.$refs.paid_in_coupon.focus()
          this.$refs.paid_in_coupon.select()
        })
      }
      this.calculate()
    }
  },
  watch: {
    isActive: {
      handler() {
        this.calculate()
      },
      deep: true
    },
    'model.is_city_ledger': function (val) {
      this.setValueCash(val)
    },
    'model.is_customer_ledger': function (val) {
      this.setValueCash(val)
    },
    'model.discount_type': function (val) {
      if (val) {
        this.calculate()
      }
    }
  }
}
</script>
<style scoped>
.invoice {
  padding: 0 20px 0 20px;
}

.invoice-header {
  padding: 1px;
}

.invoice .invoice-from {
  padding: 5px 20px;
}

.invoice .invoice-to {
  padding: 2px 20px;
}

.invoice .invoice-date {
  padding: 2px 20px;
}

.invoice>div:not(.invoice-footer) {
  margin-bottom: 10px;
}

.table>thead>tr>th,
.table>tbody>tr>th,
.table>tfoot>tr>th,
.table>thead>tr>td,
.table>tbody>tr>td,
.table>tfoot>tr>td {
  padding: 3px 5px;
}

.table-responsive {
  max-height: 15vh;
  overflow-x: scroll;
  overflow-y: scroll;
}

.table>thead>tr>th {
  position: sticky;
  top: 0;
  background: rgba(230, 230, 230, 1);
  z-index: 10;
}

.invoice .invoice-price .invoice-price-left {
  padding: 2px 10px;
  font-size: 15px;
}

.invoice .invoice-price .invoice-button {
  font-size: 23px;
  margin-left: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: flex-end;
  -ms-flex-pack: flex-end;
  justify-content: flex-end;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
}

.invoice .invoice-price .invoice-button .btn-default {
  height: 122px;
  background: #d6dce0;
  border-color: #d6dce0;
  border-radius: 0%;
}

.invoice .invoice-price .invoice-price-right {
  padding: 10px 10px;
  font-size: 23px;
  min-width: 41%;
}

.widget-table-img {
  width: 100px;
  height: auto;
}

.payment-type {
  font-size: 2.5rem;
  margin: 0;
}

.payment-type>li.active a {
  color: #2d353c;
}

.payment-type>li a {
  color: #999;
}

.form-control-lg {
  background: #fffefe;
}

.payment {
  background: #f2f3f4;
  padding: 0 0 5px 5px;
}

.invoice-footer {
  padding-top: 0;
}

.btn-row .btn {
  padding: 25px 25px;
  font-size: 0.875rem;
  min-width: 250px;
  text-align: center;
  position: relative;
  border-radius: 0;
}

.invoice .invoice-price .invoice-price-left .invoice-price-row .sub-price {
  padding: 0 10px;
}

#keyboard {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
